import { useSelector } from 'react-redux';
import Header from "../../shared/header/header";
import { withTranslation } from 'react-i18next';
import React, { Fragment } from "react";
import Sidebar from "../../public/sidebar/sidebar";
import { moduleAction } from "../../utils/functions";
import { getRoles } from '../../../Redux/reducer/session';
import { EXECUTE, MOD_CUSTOM, MOD_LOG, MOD_PARAM, MOD_PROVID } from '../../../permissions';

const MainTemplate = (props) => {
  const roles = useSelector(state => getRoles(state));

  const getAvailableModules = () => {
    var routes = [];
    var hasAdmission = false;
    const { t } = props;

    Object.keys(roles).map((item) => {
      switch (item) {
        case MOD_CUSTOM:
          routes.push({
            id: "clients",
            path: "/bscadministrator/home",
            label: t('sidebarMenu.clients.web'),
            labelMobile: t('sidebarMenu.clients.mobile'),
          });
          if (moduleAction(roles, item, EXECUTE) && hasAdmission === false) {
            routes.push({
              id: "admissions",
              path: "/bscadministrator/aprovals",
              label: t('sidebarMenu.admissions.web'),
              labelMobile: t('sidebarMenu.admissions.mobile'),
            });
            hasAdmission = true;
          }
          break;
        case MOD_LOG:
          routes.push({
            id: "auditLogs",
            path: "/bscadministrator/logs",
            label: t('sidebarMenu.auditLogs.web'),
            labelMobile: t('sidebarMenu.auditLogs.mobile'),
          });
          break;
        case MOD_PROVID:
          routes.push({
            id: "provider",
            path: "/bscadministrator/providers",
            label: t('sidebarMenu.provider.web'),
            labelMobile: t('sidebarMenu.provider.mobile'),
          });
          if (moduleAction(roles, item, EXECUTE) && hasAdmission === false) {
            routes.push({
              id: "admissions",
              path: "/bscadministrator/aprovals",
              label: t('sidebarMenu.admissions.web'),
              labelMobile: t('sidebarMenu.admissions.mobile'),
            });
            hasAdmission = true;
          }
          break;
        case MOD_PARAM:
          routes.push({ 
            id: "notifications",
            path: "/bscadministrator/notifications",
            label: t('sidebarMenu.notifications.web'),
            labelMobile: t('sidebarMenu.notifications.mobile')
          })
          if (moduleAction(roles, item, EXECUTE) && hasAdmission === false) {
            routes.push({
              id: "admissions",
              path: "/bscadministrator/aprovals",
              label: t('sidebarMenu.admissions.web'),
              labelMobile: t('sidebarMenu.admissions.mobile'),
            });
            hasAdmission = true;
          }
          break;
      }

      return true;
    });

    routes.push({ id: "reports", path: "/bscadministrator/audit-reports", label: t('sidebarMenu.reports.web'), labelMobile: t('sidebarMenu.reports.mobile') });
    return routes;
  };

  const customClass = props.customClass || "";
  return <Fragment>
    <Header />
    <Sidebar menuItems={getAvailableModules()} className="backoffice" />
    <div className={`wrapper-container-backoffice ${customClass}`}>
      <div className="content-backoffice">{props.children}</div>
    </div>
  </Fragment>
};

export default withTranslation()(MainTemplate);
